import { render, staticRenderFns } from "./ModalEventMessage.vue?vue&type=template&id=1a52e8d8&"
import script from "./ModalEventMessage.vue?vue&type=script&lang=js&"
export * from "./ModalEventMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports